<template>
  <!-- Modal de Receita Fixa -->
  <CModal
    v-model:visible="modalReceitaFixa.exibir"
    size="lg"
    alignment="center"
    @close="fecharModalReceitaFixa"
  >
    <CModalHeader>
      <CModalTitle>
        <font-awesome-icon icon="fas fa-dollar-sign" class="me-2" />
        Detalhes
      </CModalTitle>
    </CModalHeader>
    <CModalBody v-if="modalReceitaFixa.receita">
      <!-- Alerta de cartório diferente -->
      <CAlert
        v-if="modalReceitaFixa.cartorioDiferente && modalReceitaFixa.cartorioInfo"
        color="info"
        class="mb-3"
      >
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <CIcon icon="cil-info" class="me-2" />
            Esta receita pertence ao cartório {{ usuarioStore.formatarNomeCartorio(modalReceitaFixa.cartorioInfo) }}, diferente do cartório atualmente selecionado.
          </div>
          <CButton
            color="primary"
            size="sm"
            @click="trocarCartorio"
          >
            Trocar para este cartório
          </CButton>
        </div>
      </CAlert>

      <CRow>
        <CCol md="12" class="mb-3">
          <h6 class="text-muted mb-1">
            Descrição
          </h6>
          <p class="mb-0 fs-5">
            {{ modalReceitaFixa.receita.descricao || 'Sem descrição' }}
          </p>
        </CCol>
        <CCol md="6" class="mb-3">
          <h6 class="text-muted mb-1">
            Valor
          </h6>
          <p class="mb-0 text-success">
            R$ {{ parseFloat(modalReceitaFixa.receita.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
          </p>
        </CCol>
        <CCol md="6" class="mb-3">
          <h6 class="text-muted mb-1">
            Data
          </h6>
          <p class="mb-0">
            {{ modalReceitaFixa.receita.data ? new Date(modalReceitaFixa.receita.data).toLocaleDateString('pt-BR') : '-' }}
          </p>
        </CCol>
        <CCol v-if="modalReceitaFixa.receita.observacao" md="12" class="mb-3">
          <h6 class="text-muted mb-1">
            Observação
          </h6>
          <p class="mb-0">
            {{ modalReceitaFixa.receita.observacao }}
          </p>
        </CCol>
      </CRow>
    </CModalBody>
    <CModalFooter>
      <CButton color="secondary" @click="fecharModalReceitaFixa">
        Fechar
      </CButton>
    </CModalFooter>
  </CModal>
</template>

<script setup lang="ts">
const store = usePrestacaoDeContaStore()
const { modalReceitaFixa } = storeToRefs(store)
const usuarioStore = useUsuarioStore()

const fecharModalReceitaFixa = () => {
  store.resetarModalReceitaFixa()
}

// Função para trocar cartório
async function trocarCartorio () {
  try {
    if (modalReceitaFixa.value.cartorioInfo?.id) {
      await usuarioStore.selecionarCartorio(modalReceitaFixa.value.cartorioInfo.id, true)
      // Modal permanece aberto com manterContexto = true

      // Atualizar flags para ocultar o alerta
      modalReceitaFixa.value.cartorioDiferente = false
      modalReceitaFixa.value.cartorioInfo = null
    }
  } catch (error) {
    console.error('Erro ao trocar cartório:', error)
    useStore().toasts.push({
      content: 'Erro ao trocar de cartório',
      color: 'danger',
    })
  }
}
</script>
